import { c as _c } from "react/compiler-runtime";
import { ServiceMarketplaceCard } from '../service-marketplace-card';
import type { EnrichedService } from '../../types';
interface ServicesCategorySectionProps {
  title: string;
  services: EnrichedService[];
}
function ServicesCategorySection(t0) {
  const $ = _c(14);
  const {
    title,
    services
  } = t0;
  if (services.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== title) {
    t1 = <h2 className="text-foreground text-xl leading-tight font-bold">{title}</h2>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== services.length) {
    t2 = <span className="text-muted-foreground text-sm">{services.length} services</span>;
    $[2] = services.length;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className="flex items-baseline gap-2">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== services) {
    t4 = services.map(_temp);
    $[7] = services;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <section className="flex flex-col gap-4">{t3}{t5}</section>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(enrichedService) {
  return <ServiceMarketplaceCard key={enrichedService.service.id} enrichedService={enrichedService} />;
}
export { ServicesCategorySection };